// import { styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import styled from "@emotion/styled";
import { Switch } from "@mui/material";
import { appColors } from "../../constants/theme";
import { LAYOUT_HEADER_HEIGHT } from "../../constants/appConstants";

// Drawer
export const drawerWidth = 280;
// AppBar
export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: "white !important",
  color: `${appColors.gray900} !important`,
  boxShadow: "0 1px 0 rgba(15, 23, 42, 0.06)",

  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  "& .MuiToolbar-root": {
    height: LAYOUT_HEADER_HEIGHT,
    minHeight: LAYOUT_HEADER_HEIGHT,
    maxHeight: LAYOUT_HEADER_HEIGHT,
    boxSizing: "border-box",
    padding: "0 24px",
    gap: 8,
    [theme.breakpoints.down("md")]: {
      height: 64,
      minHeight: 64,
      maxHeight: 64,
      padding: "0 12px",
      gap: 4,
    },
  },
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  [theme.breakpoints.down("md")]: {
    marginLeft: 0,
    width: "100%",
  },
}));

export const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: appColors.white,
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? appColors.successDark : appColors.success,
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: appColors.successDark,
      border: `6px solid ${appColors.white}`,
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? appColors.gray200 : appColors.materialGrayDark,
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

export const InnerToolBarContianer = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;
